import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { LoadingOverlay } from '../../components/LoadingOverlay/LoadingOverlay';
import { Page } from '../../components/Page';
import PageHeader from '../../components/PageHeader';
import getEmails from './getEmails.api';
import Results from './Results';
import EmailEdit from './EmailEdit';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    }
}));

const EmailList = () => {
    const classes = useStyles();
    const emailsData = getEmails();
    const title = 'Email Management';
    const [openModal, setOpenModal] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState({});
    const handleModalOpen = () => {
        setOpenModal(true);
    };
    const handleModalClose = () => {
        setSelectedEmail({});
        setOpenModal(false);
    };
    const handleSetSelectedEmail = (email: any) => {
        setSelectedEmail(email);
    };

    return (
        <Page className={classes.root} title={title}>
            <PageHeader
                section="Users"
                title={title}
                action={{
                    permission: 'email.create',
                    label: 'Add Email',
                    onClick: handleModalOpen
                }}
            />
            <LoadingOverlay loading={emailsData.loading}>
                {emailsData.data && emailsData.data.emails && (
                    <Results
                        className={classes.results}
                        emails={emailsData.data.emails}
                        setEmail={handleSetSelectedEmail}
                        openModal={handleModalOpen}
                    />
                )}
            </LoadingOverlay>
            <EmailEdit
                email={selectedEmail}
                onClose={handleModalClose}
                open={openModal}
            />
        </Page>
    );
};

export default EmailList;
